import IntlMessages from 'components/utility/IntlMessages';
import styled from 'styled-components';

import { palette } from 'styled-theme';

const StyledMaintenance = styled.div`
  h1 {
    color: #fff;
  }
  .hrl-page-bg {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: radial-gradient(50% 60% at 50% 50%, ${palette('rebrandFushia', 8)} 0%, ${palette('rebrandFushia', 9)} 100%);
    overflow: hidden;
  }

  /* Info */
  .hrl-info {
    font-family: 'Museo Sans', sans-serif;
    color: white;
    text-align: center;
    margin-top: 10vh;
    padding: 0 2rem;
  }

  .hrl-info h1 {
    font-size: 5vw;
    line-height: 100%;
    font-weight: 500;
    margin-top: 0;
    margin-bottom: 2vh;
  }

  .hrl-info p {
    font-size: 4vw;
    line-height: 150%;
    font-weight: 300;
    margin: 0;
  }

  /* Cloud */
  .hrl-cloud {
    position: absolute;
    bottom: -15vh;
    left: -25vw;
    width: 150vw;
    height: auto;
  }

  .hrl-cloud svg {
    width: 100%;
    height: auto;
  }

  /* HR Labrador */
  .hrl-labrador {
    position: absolute;
    bottom: 10vw;
    left: 15vw;
  }

  .hrl-labrador svg {
    width: 60vw;
    height: auto;
    max-width: 500px;
  }

  #head-helm {
    animation: wave-head 2s ease infinite alternate;
    transform-origin: bottom;
    transform-box: fill-box;
  }
  #tail {
    animation: wave 0.5s ease infinite alternate;
    transform-origin: right;
    transform-box: fill-box;
  }
  #right-ear {
    animation: wave 5s linear infinite alternate;
    transform-origin: left;
    transform-box: fill-box;
  }
  #left-ear {
    animation: wave 5s linear infinite alternate;
    transform-origin: top;
    transform-box: fill-box;
  }
  #left-hand-tool {
    animation: fixing 1s infinite alternate;
    transform-origin: top;
    transform-box: fill-box;
  }

  #top-gear {
    animation: small-gear-turn 7s ease infinite;
    transform-origin: center;
    transform-box: fill-box;
  }
  #big-gear {
    animation: big-gear-turn 7s ease infinite;
    transform-origin: center;
    transform-box: fill-box;
  }
  #left-gear {
    animation: small-gear-turn 7s ease infinite;
    transform-origin: center;
    transform-box: fill-box;
  }

  @keyframes big-gear-turn {
    from {
      transform: rotateZ(360deg);
    }
    to {
      transform: rotateZ(0deg);
    }
  }

  @keyframes fixing {
    from {
      transform: rotateZ(0deg);
    }
    to {
      transform: rotateZ(10deg);
    }
  }

  @keyframes wave {
    from {
      transform: rotateZ(-10deg);
    }
    to {
      transform: rotateZ(10deg);
    }
  }

  @keyframes wave-head {
    from {
      transform: rotateZ(-5deg);
    }
    to {
      transform: rotateZ(5deg);
    }
  }

  @keyframes small-gear-turn {
    from {
      transform: rotateZ(0deg);
    }
    to {
      transform: rotateZ(360deg);
    }
  }

  /* Landscape */
  @media (orientation: landscape) {
    /* Info */
    .hrl-info {
      margin-top: 15vh;
      padding: 0 2rem;
    }

    .hrl-info p {
      display: none;
    }

    /* Cloud */
    .hrl-cloud {
      position: absolute;
      top: 30vh;
      left: -15vw;
      width: 125vw;
      height: auto;
    }

    .hrl-cloud svg {
      width: 100%;
      height: auto;
    }

    /* HR Labrador */
    .hrl-labrador {
      position: absolute;
      bottom: 3vw;
      left: 30vw;
    }

    .hrl-labrador svg {
      width: 25vw;
      height: auto;
    }
  }

  /* Desktop */
  @media (min-width: 960px) {
    /* Info */
    .hrl-info {
      text-align: left;
      margin-top: 20vh;
      padding: 0 15vh;
      width: 70vw;
    }

    .hrl-info h1 {
      font-size: 2.5vw;
      line-height: 1.25;
    }

    .hrl-info p {
      display: block;
      font-size: 1.5vw;
      line-height: 150%;
      margin: 0;
    }

    /* Cloud */
    .hrl-cloud {
      top: 35vh;
      left: 40vw;
    }

    .hrl-cloud svg {
      width: 60%;
    }

    /* HR Labrador */
    .hrl-labrador {
      position: absolute;
      left: auto;
      bottom: 8vh;
      right: 8vw;
    }

    .hrl-labrador svg {
      width: 45vh;
      height: auto;
      max-width: 500px;
    }
  }
`;

const Maintenance = () => {
  return (
    <>
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/normalize/8.0.1/normalize.min.css"
      />
      <link rel="stylesheet" href="https://use.typekit.net/fhr7xxn.css" />
      <StyledMaintenance>
        <div className="hrl-page-bg">
          <div className="hrl-info">
            <h1>
              <IntlMessages id="maintenance.paragraph1" />
            </h1>
            <p>
              <IntlMessages id="maintenance.paragraph2" />
            </p>
          </div>

          <div className="hrl-cloud">
            <svg viewBox="0 0 1400 1000" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1329.72 603.39C1371.64 622.373 1400 657.627 1400 696.949C1400 728.814 1381.51 757.966 1353.76 778.305V783.051C1353.76 829.153 1304.45 865.763 1243.42 866.441C1219.99 886.102 1182.39 898.983 1140.47 898.983C1128.75 898.983 1117.66 898.305 1107.18 896.271C1096.08 928.136 1031.97 951.865 954.293 951.865C935.799 951.865 917.922 950.508 901.277 947.797V950.508C901.277 977.627 843.329 1000 771.202 1000C719.419 1000 675.033 988.475 654.073 972.203C636.195 983.729 613.386 990.508 588.727 990.508C543.725 990.508 504.888 967.458 490.709 936.271C474.681 949.153 450.022 957.288 422.281 957.288C375.429 957.288 337.208 934.237 334.742 905.085C331.044 905.763 327.961 905.763 324.262 905.763C270.013 905.763 225.627 868.475 225.627 822.373C225.627 811.525 228.093 801.356 232.409 791.864C223.162 793.898 213.298 794.576 203.435 794.576C138.089 794.576 85.0727 758.644 85.0727 715.254C85.0727 684.746 110.964 658.305 148.569 645.424C113.43 636.61 88.7715 611.525 88.7715 582.373C88.7715 557.288 106.649 535.593 133.157 524.068C106.033 502.373 89.3879 473.898 89.3879 442.712C89.3879 402.034 117.745 365.424 161.515 343.051C143.637 336.949 131.924 327.458 131.924 316.61C131.924 303.051 151.035 291.525 178.159 286.102C167.063 277.966 160.282 267.797 160.282 256.949C160.282 228.475 205.9 205.424 262.616 204.746C259.533 198.644 257.684 191.864 257.684 185.085C257.684 143.729 318.714 109.83 395.156 109.153C393.307 105.085 392.69 101.695 392.69 97.6271C392.69 75.9322 417.349 58.9831 448.173 58.9831C464.201 58.9831 478.996 63.7288 488.86 71.1864C504.271 63.7288 523.998 58.9831 545.575 58.9831H549.273C546.807 55.5932 545.575 52.2034 545.575 48.8136C545.575 31.8644 576.398 18.3051 614.003 18.3051C651.607 18.3051 682.431 31.8644 682.431 48.8136C682.431 50.8475 681.198 53.5593 679.965 56.2712L687.362 58.3051C702.774 49.4915 723.118 42.7119 745.31 41.3559V39.322C745.31 17.6271 768.736 0 797.71 0C826.684 0 850.11 17.6271 850.11 39.322C850.11 46.7797 847.644 52.8814 843.329 58.9831C861.207 47.4576 885.249 40.678 911.141 40.678C954.91 40.678 991.898 59.661 1007.31 86.7797C1024.57 69.8305 1051.7 58.9831 1082.52 58.9831C1128.75 58.9831 1166.97 83.3898 1174.37 115.932C1179.3 115.254 1184.24 114.576 1189.17 114.576H1192.25C1181.77 110.508 1174.99 104.407 1174.99 96.9492C1174.99 85.4237 1192.25 75.9322 1214.44 75.9322C1236.02 75.9322 1253.9 85.4237 1253.9 96.9492C1253.9 108.475 1236.64 117.966 1214.44 117.966H1213.21C1234.17 124.746 1248.97 139.661 1249.58 157.288V158.644C1249.58 166.78 1247.12 174.237 1242.18 180.339C1273.62 191.186 1295.82 213.559 1295.82 240C1295.82 246.78 1293.97 253.559 1290.89 260.339C1335.27 261.017 1371.03 293.559 1371.03 332.881C1371.03 362.034 1351.3 387.119 1323.56 398.644C1360.55 400.678 1390.14 425.085 1390.14 454.915C1390.14 479.322 1370.41 499.661 1342.67 507.797C1357.46 518.644 1366.71 534.237 1366.71 551.864C1366.71 574.237 1351.92 593.22 1329.72 603.39ZM1269.31 79.322C1294.84 79.322 1315.54 69.6089 1315.54 57.6271C1315.54 45.6453 1294.84 35.9322 1269.31 35.9322C1243.77 35.9322 1223.07 45.6453 1223.07 57.6271C1223.07 69.6089 1243.77 79.322 1269.31 79.322ZM20.3435 363.39C20.3435 353.898 30.207 346.441 43.1528 346.441C55.4822 346.441 65.9621 353.898 65.9621 363.39C65.9621 372.881 56.0986 380.339 43.1528 380.339C30.8234 380.339 20.3435 372.881 20.3435 363.39ZM182.475 816.271C182.475 813.559 175.694 810.847 167.679 810.847C159.665 810.847 152.884 812.881 152.884 816.271C152.884 818.983 159.665 821.695 167.679 821.695C175.694 821.695 182.475 819.661 182.475 816.271ZM213.915 854.237C213.915 842.712 199.736 833.22 182.475 833.22C165.214 833.22 151.035 842.712 151.035 854.237C151.035 865.763 165.214 875.254 182.475 875.254C199.736 875.254 213.915 865.763 213.915 854.237ZM1293.35 164.068C1276.09 164.068 1261.91 156.61 1261.91 147.797C1261.91 138.983 1276.09 131.525 1293.35 131.525C1310.61 131.525 1324.79 138.983 1324.79 147.797C1324.79 156.61 1310.61 164.068 1293.35 164.068ZM104.183 292.881C104.183 287.458 95.5526 283.39 85.0727 283.39H80.7574C80.886 282.965 81.0146 282.571 81.1376 282.193L81.1377 282.193C81.6043 280.76 81.9903 279.576 81.9903 277.966C81.9903 264.407 63.4963 253.559 40.6869 253.559C17.8776 253.559 0 264.407 0 277.966C0 291.525 18.4941 302.373 41.3034 302.373C51.1669 302.373 60.4139 300.339 67.8115 296.271C70.8939 299.661 77.675 302.373 85.6891 302.373C95.5526 302.373 104.183 298.305 104.183 292.881Z"
                fill="url(#paint0_linear)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear"
                  x1="700"
                  y1="0"
                  x2="700"
                  y2="1000"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" />
                  <stop offset="1" stopColor="#F2F2F7" />
                </linearGradient>
              </defs>
            </svg>
          </div>

          <div className="hrl-labrador">
            <svg viewBox="0 0 500 387" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="labrador-maintenance" clipPath="url(#clip0)">
                <g id="labrador-body" filter="url(#filter0_d)">
                  <path
                    id="body-shadow"
                    opacity="0.15"
                    d="M170.655 385.127C170.655 385.127 208.671 347.46 200.224 336.122C191.779 324.785 130.706 305.565 106.202 311.739C104.157 312.254 101.007 321.756 90.8916 310.494C79.7542 298.092 41.1335 300.152 73.1 343.953C106.681 389.965 170.655 385.127 170.655 385.127Z"
                    fill="#A9A5A3"
                    fillOpacity="0.04"
                  />
                  <g id="tail">
                    <path
                      id="tail_2"
                      d="M83.9602 291.827C66.7958 286.488 44.215 296.184 43.293 276.078C42.371 255.972 11.618 275.859 37.2243 289.691C62.8314 303.524 72.7044 304.048 79.8714 304.506C87.0385 304.963 83.9602 291.827 83.9602 291.827Z"
                      fill="#D9CEBB"
                    />
                  </g>
                  <g id="right-hand">
                    <path
                      id="right-hand_2"
                      d="M203.586 264.994C189.688 259.59 176.461 260.211 174.042 266.381C171.624 272.552 180.93 281.934 194.828 287.338C208.726 292.742 221.953 292.121 224.372 285.951C226.79 279.78 217.484 270.398 203.586 264.994Z"
                      fill="#D9CEBB"
                    />
                  </g>
                  <path
                    id="body"
                    d="M131.816 240.935C131.816 240.935 91.9435 253.431 79.5979 273.217C63.8485 298.458 70.1988 310.97 77.5096 319.725C84.8204 328.479 105.707 347.63 109.884 350.365C114.062 353.1 128.161 373.345 146.959 353.1C165.757 332.856 183.511 325.196 184.556 314.8C185.6 304.404 196.044 307.687 199.699 263.915C203.355 220.143 131.816 240.935 131.816 240.935Z"
                    fill="#CABCAF"
                  />
                  <g id="left-hand-tool">
                    <g id="tool">
                      <g id="tool-front-parts">
                        <path
                          d="M261.084 298.711C263.984 298.856 264.965 302.711 262.505 304.292L247.184 314.129C245.46 315.236 243.185 314.299 242.712 312.288L240.19 301.557C239.728 299.592 241.256 297.719 243.241 297.819L261.084 298.711Z"
                          fill="#5D5D5D"
                        />
                        <path
                          d="M268.032 325.95C270.992 325.974 272.087 329.905 269.585 331.527L253.052 342.243C251.329 343.36 249.044 342.425 248.57 340.409L246.013 329.533C245.563 327.617 247.006 325.774 248.943 325.791L268.032 325.95Z"
                          fill="#5D5D5D"
                        />
                      </g>
                      <path
                        id="tool-vertical-part"
                        d="M240.76 297.882C242.896 297.384 245.016 298.742 245.495 300.915L253.662 337.968C254.141 340.141 252.798 342.306 250.661 342.804L244.764 344.18C242.627 344.678 240.507 343.32 240.028 341.147L231.861 304.094C231.382 301.921 232.726 299.756 234.862 299.258L240.76 297.882Z"
                        fill="#5D5D5D"
                      />
                      <path
                        id="tool-handle"
                        d="M167.497 337.917L234.095 323.066"
                        stroke="#5D5D5D"
                        strokeWidth="18"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                      />
                    </g>
                    <path
                      id="left-hand"
                      d="M146.071 302.046C142.34 287.171 148.624 280.179 164.596 289.963C180.567 299.747 190.049 313.751 193.78 328.625C197.511 343.499 194.077 353.609 178.106 343.825C162.135 334.041 149.802 316.92 146.071 302.046Z"
                      fill="#D9CEBB"
                    />
                  </g>
                  <path
                    id="head-shadow"
                    opacity="0.3"
                    d="M128.614 225.991C128.614 225.991 114.956 254.897 121.039 262.444C127.122 269.991 164.01 287.948 175.573 276.017C176.538 275.021 176.668 265.947 183.593 272.982C191.218 280.727 210.637 268.566 187.474 239.23C163.141 208.414 128.614 225.991 128.614 225.991Z"
                    fill="#A9A5A3"
                  />
                </g>
                <g id="gear">
                  <g id="top-gear">
                    <circle
                      id="top-gear-teeth"
                      cx="404.5"
                      cy="128.5"
                      r="32.5"
                      stroke="#51334B"
                      strokeWidth="20"
                      strokeDasharray="15 15"
                    />
                    <circle
                      id="top-gear-circle"
                      cx="404.5"
                      cy="128.5"
                      r="31.875"
                      fill="url(#paint0_radial)"
                    />
                  </g>
                  <g id="big-gear">
                    <circle
                      id="big-gear-teeth"
                      cx="385.224"
                      cy="234.224"
                      r="65"
                      transform="rotate(-29.5324 385.224 234.224)"
                      stroke="#51334B"
                      strokeWidth="20"
                      strokeDasharray="20 20"
                    />
                    <circle
                      id="big-gear-circle"
                      cx="384.543"
                      cy="234.036"
                      r="61.5"
                      transform="rotate(-29.5324 384.543 234.036)"
                      fill="url(#paint1_radial)"
                    />
                  </g>
                  <g id="left-gear">
                    <circle
                      id="left-gear-teeth"
                      cx="305"
                      cy="315"
                      r="42.5"
                      stroke="#51334B"
                      strokeWidth="15"
                      strokeDasharray="20 20"
                    />
                    <circle
                      id="left-gear-circle"
                      cx="305.5"
                      cy="315.5"
                      r="37.5"
                      fill="url(#paint2_radial)"
                    />
                  </g>
                </g>
                <g id="head-helm">
                  <g id="labrador-head" filter="url(#filter1_d)">
                    <g id="left-ear">
                      <path
                        id="left-ear_2"
                        d="M30.1205 145.904C35.3173 128.132 36.5499 129.453 39.5787 128.478C42.6064 127.503 59.5631 123.386 70.3327 103.014C81.1023 82.6423 105.376 93.5854 106.108 91.6563C106.84 89.7262 75.0508 223.185 60.1645 211.72C45.2781 200.254 48.3507 159.107 30.1205 145.904Z"
                        fill="#CABCAF"
                      />
                    </g>
                    <g id="right-ear">
                      <path
                        id="right-ear_2"
                        d="M296.549 158.056C292.551 161.977 306.927 200.764 277.475 183.439C275.381 182.207 265.078 173.198 265.078 173.198C265.078 173.198 208.233 84.8016 221.008 78.9113C234.093 72.8782 230.749 75.9986 259.322 86.7241L309.118 114.544C314.8 115.017 314.28 127.866 308.683 131.671L296.549 158.056Z"
                        fill="#CABCAF"
                      />
                      <path
                        id="right-ear-eyeshadow"
                        opacity="0.3"
                        d="M273.957 153.241C273.957 153.241 257.772 177.444 251.674 170.745C245.576 164.046 263.066 155.662 264.795 133.485C264.917 131.923 244.451 106.05 238.663 98.3423C232.289 89.8555 238.301 69.9665 261.965 95.444C286.823 122.21 273.957 153.241 273.957 153.241Z"
                        fill="#A9A5A3"
                      />
                    </g>
                    <path
                      id="head"
                      d="M81.2951 147.253C81.2951 147.253 78.0597 96.4911 104.093 81.5398C116.577 74.3699 125.937 67.6547 157.55 61.8606C187.03 56.4572 210.221 64.6722 220.441 70.2944C230.66 75.9166 267.215 100.164 267.215 127.925C267.215 155.687 267.528 196.963 260.846 203.641C254.164 210.317 256.603 209.452 245.597 215.075C234.591 220.697 264.465 232.645 218.869 255.838C216.117 257.596 172.486 261.812 176.418 241.782C176.418 241.782 181.528 260.758 145.758 263.921C109.989 267.084 113.919 226.32 115.491 226.32C115.569 226.32 114.436 221.554 110.991 216.631C107.241 211.27 101.116 205.665 100.263 204.308C88.6692 185.861 76.4847 161.227 81.2951 147.253Z"
                      fill="#D9CEBB"
                    />
                    <path
                      id="face-light-nose"
                      d="M204.236 224.604C204.171 231.029 198.72 235.54 189.728 235.449L172.767 235.278C163.774 235.187 158.419 230.567 158.484 224.143L156.868 197.791C156.934 191.366 124.755 152.36 133.748 152.45L181.081 163.67L228.528 155.906C237.521 155.996 206.46 191.867 206.394 198.292L204.236 224.604Z"
                      fill="#EEE2D6"
                    />
                    <path
                      id="sniff-light"
                      d="M125.162 245.262C125.689 251.29 129.275 264.062 138.977 264.547C140.29 264.613 149.995 264.646 158.852 261.52C167.994 258.293 176.289 251.901 177.28 251.914C182.606 251.986 189.826 259.57 197.139 258.428C202.99 257.514 213.578 255.017 216.718 253.721C224.325 250.582 228.84 243.963 227.873 232.895C225.692 207.952 198.002 193.451 170.682 195.816C143.361 198.18 122.982 220.318 125.162 245.262Z"
                      fill="#EEE2D6"
                    />
                    <g id="left-eye">
                      <path
                        id="left-sclera"
                        d="M157.421 179.91C157.378 192.003 145.145 203.935 130.097 206.561C115.049 209.187 98.3792 202.298 98.4213 190.204C98.4643 178.111 115.776 154.999 130.824 152.374C145.872 149.748 157.464 167.817 157.421 179.91Z"
                        fill="#F6F4FC"
                      />
                      <path
                        id="left-pupil"
                        d="M155.72 184.018C153.309 195.733 140.334 203.668 126.742 201.742C113.15 199.816 104.086 188.758 106.498 177.043C108.909 165.328 121.884 157.393 135.476 159.318C149.068 161.244 158.132 172.303 155.72 184.018Z"
                        fill="black"
                      />
                      <path
                        id="left-iris"
                        d="M151.411 185.976C150.834 188.918 146.59 190.694 141.932 189.943C137.273 189.191 133.965 186.197 134.542 183.254C135.12 180.312 139.363 178.536 144.022 179.287C148.68 180.039 151.989 183.033 151.411 185.976Z"
                        fill="#F6F4FC"
                      />
                      <path
                        id="left-eyeshadow"
                        d="M113.353 175.536C112.353 180.501 112.883 184.719 114.536 184.959C116.19 185.198 118.342 181.368 119.342 176.403C120.342 171.438 119.812 167.22 118.159 166.98C116.504 166.74 114.353 170.571 113.353 175.536Z"
                        fill="#7B7A7E"
                      />
                      <path
                        id="left-eyeshadow_2"
                        d="M155.453 190.235C155.453 190.235 122.55 160.523 104.372 174.063C104.372 174.063 112.354 158.644 123.318 148.285C136.024 136.281 161.519 161.673 155.453 190.235Z"
                        fill="#CABCAF"
                      />
                    </g>
                    <path
                      id="mouth-triangle"
                      d="M172.703 255.735L183.703 255.49L175.483 247.735"
                      fill="#5D5D5D"
                    />
                    <path
                      id="mouth"
                      d="M144.934 246.396C144.934 246.396 141.627 260.027 165.19 259.106C177.428 258.627 176.826 236.93 176.623 239.337C176.623 239.337 173.699 261.963 200.634 256.082C215.537 249.95 209.613 246.84 209.613 246.84"
                      stroke="black"
                      strokeMiterlimit="10"
                    />
                    <g id="nose">
                      <path
                        id="nose_2"
                        d="M191.869 236.573C191.869 231.655 184.839 227.667 176.167 227.667C167.495 227.667 157.869 231.654 157.869 236.573C157.869 241.492 167.804 249.667 176.476 249.667C185.148 249.667 191.869 241.492 191.869 236.573Z"
                        fill="#271D19"
                      />
                      <path
                        id="nose-light"
                        d="M183.048 234.875C186.448 234.875 189.206 234.286 189.206 233.559C189.206 232.832 186.448 232.242 183.048 232.242C179.647 232.242 176.889 232.832 176.889 233.559C176.889 234.286 179.647 234.875 183.048 234.875Z"
                        fill="#7B7A7E"
                      />
                    </g>
                    <g id="right-eye">
                      <path
                        id="right-sclera"
                        d="M207.793 183.781C206.871 195.715 217.475 208.245 231.479 211.767C245.483 215.29 261.774 209.525 262.695 197.591C263.617 185.657 249.105 161.783 235.102 158.26C221.099 154.737 208.714 171.846 207.793 183.781Z"
                        fill="#F6F4FC"
                      />
                      <path
                        id="right-pupil"
                        d="M210.671 190.096C212.119 203.029 223.747 212.637 236.644 211.556C249.54 210.476 258.821 199.116 257.373 186.182C255.925 173.249 244.297 163.642 231.401 164.722C218.504 165.803 209.223 177.164 210.671 190.096Z"
                        fill="#0A0C0C"
                      />
                      <path
                        id="right-eyeshadow"
                        d="M221.186 190.03C221.76 195.275 223.485 199.419 225.039 199.286C226.592 199.153 227.386 194.793 226.812 189.548C226.237 184.302 224.512 180.159 222.959 180.292C221.405 180.425 220.611 184.784 221.186 190.03Z"
                        fill="#7B7A7E"
                      />
                      <path
                        id="left-eyelid"
                        d="M245.083 188.092C245.35 190.818 248.917 192.67 253.05 192.231C257.183 191.791 260.318 189.225 260.051 186.499C259.784 183.773 256.217 181.92 252.084 182.36C247.951 182.799 244.816 185.366 245.083 188.092Z"
                        fill="#F6F4FC"
                      />
                      <path
                        id="right-eyelid"
                        d="M208.221 188.356C208.221 188.356 254.66 167.721 260.503 186.599C260.503 186.599 248.147 159.818 238.3 150.889C226.89 140.54 203.076 163.669 208.221 188.356Z"
                        fill="#CABCAF"
                      />
                    </g>
                    <path
                      id="left-eyebrow"
                      d="M153.799 166.405C153.799 166.405 142.586 117.019 97.7994 181.683C97.7994 181.683 102.547 156.06 110.286 141.639C119.253 124.928 150.754 135.178 153.799 166.405Z"
                      fill="#EEE2D6"
                    />
                    <path
                      id="right-eyebrow"
                      d="M211.359 164.68C211.359 164.68 226.484 117.462 263.359 182.593C263.359 182.593 261.136 157.507 255.057 143.108C248.011 126.42 217.068 134.598 211.359 164.68Z"
                      fill="#EEE2D6"
                    />
                  </g>
                  <g id="helm">
                    <path
                      id="helm-bottom"
                      d="M70.0534 141.099C64.542 141.453 59.7872 137.273 59.4333 131.762L58.5361 117.79C58.1822 112.279 62.3632 107.523 67.8747 107.169L277.441 93.6789C282.952 93.3242 287.707 97.5045 288.061 103.016L288.958 116.987C289.312 122.499 285.131 127.254 279.62 127.609L70.0534 141.099Z"
                      fill="#51334B"
                    />
                    <path
                      id="helm-main"
                      d="M68.6087 118.6C65.2305 65.9899 105.14 20.596 157.75 17.2096L180.792 15.7263C233.402 12.3399 278.789 52.2434 282.167 104.853C282.505 110.114 278.514 114.654 273.253 114.992L78.7461 127.512C73.4852 127.851 68.9465 123.861 68.6087 118.6Z"
                      fill="#673C5E"
                    />
                    <path
                      id="helm-central-line"
                      d="M148.437 35.3452C147.535 21.2909 158.196 9.16428 172.25 8.25962C186.305 7.35496 198.429 18.0149 199.332 32.0692L204.618 114.4C204.795 117.156 202.705 119.533 199.949 119.711L159.034 122.344C156.278 122.522 153.901 120.432 153.724 117.676L148.437 35.3452Z"
                      fill="#51334B"
                    />
                  </g>
                </g>
              </g>
              <defs>
                <filter
                  id="filter0_d"
                  x="23.0635"
                  y="221"
                  width="251.911"
                  height="172.273"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow"
                    result="shape"
                  />
                </filter>
                <filter
                  id="filter1_d"
                  x="26.1205"
                  y="60.0963"
                  width="291.017"
                  height="212.468"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow"
                    result="shape"
                  />
                </filter>
                <radialGradient
                  id="paint0_radial"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(404.5 128.5) rotate(90) scale(31.875)"
                >
                  <stop stopColor="#EEE5EC" />
                  <stop offset="1" stopColor="#51334B" />
                </radialGradient>
                <radialGradient
                  id="paint1_radial"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(384.543 234.036) rotate(90) scale(61.5)"
                >
                  <stop stopColor="#F6F4FC" />
                  <stop offset="1" stopColor="#51334B" />
                </radialGradient>
                <radialGradient
                  id="paint2_radial"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(305.5 315.5) rotate(83.9115) scale(37.7127)"
                >
                  <stop stopColor="#EEE5EC" />
                  <stop offset="0.9998" stopColor="#673C5E" />
                  <stop offset="0.9999" stopColor="#5D5D5D" />
                  <stop offset="1" stopColor="#7B7A7E" stopOpacity="0" />
                  <stop offset="1" stopColor="#51334B" />
                </radialGradient>
                <clipPath id="clip0">
                  <rect width="500" height="387" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      </StyledMaintenance>
    </>
  );
};

export default Maintenance;
